import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Statitics from "../section/Statitics";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
export default function About() {
    const { t } = useTranslation();
    useScrollAnimation();
    return (
        <>
            <section className="landingpages">
                <div className="container h-full flex flex-col items-center justify-center text-center">
                    <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">{t("About us")}</div>
                    <div className="btmAni2000 flex items-center gap-[5px] fonbold">
                        <Link to={"/"}>{t("Home")}</Link>
                        -
                        <span className="text-[#017E89] capitalize">{t("About us")}</span>
                    </div>
                </div>
            </section>
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[50px]">
                    <div className="flex flex-col gap-[15px]">
                        <div className="btmAni25002 flex items-baseline gap-[7px]">
                            <img className="w-[35px] h-auto" src={require("../../assets/icons/lineTitle.svg").default} alt="" />
                            <div className="font-bold capitalize text-[25px] text-[#017e89]">{t("About us")}</div>
                        </div>
                        <div className="flex flex-col gap-[6px]">
                            <p className="btmAni25002 font-bold capitalize">
                                {t("about one")}
                            </p>
                            <p className="btmAni20002 font-bold capitalize">
                                {t("about two")}
                            </p>
                            <p className="btmAni3000 font-bold capitalize">
                                {t("about three")}
                            </p>
                            <p className="btmAni2500 font-bold capitalize">
                                {t("about four")}
                            </p>
                            <p className="btmAni30002 font-bold capitalize">
                                {t("about five")}
                            </p>
                            <p className="btmAni30002 font-bold capitalize">
                                {t("about six")}
                            </p>
                            <p className="btmAni30002 font-bold capitalize">
                                {t("about seven")}
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col gap-[15px]">
                        <div className="js-scroll fade-top flex items-baseline gap-[7px]">
                            <img className="w-[35px] h-auto" src={require("../../assets/icons/lineTitle.svg").default} alt="" />
                            <div className="font-bold capitalize text-[25px] text-[#017e89]">{t("Our Vision")}</div>
                        </div>
                        <div className="js-scroll fade-btm">
                            <p className="font-bold capitalize">
                                {t("Our Vision text")}
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col gap-[15px]">
                        <div className="js-scroll fade-top flex items-baseline gap-[7px]">
                            <img className="w-[35px] h-auto" src={require("../../assets/icons/lineTitle.svg").default} alt="" />
                            <div className="font-bold capitalize text-[25px] text-[#017e89]">{t("Our Mission")}</div>
                        </div>
                        <div className="js-scroll fade-btm">
                            <p className="font-bold capitalize">
                                {t("Our Mission text")}
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col gap-[15px]">
                        <div className="js-scroll fade-top flex items-baseline gap-[7px]">
                            <img className="w-[35px] h-auto" src={require("../../assets/icons/lineTitle.svg").default} alt="" />
                            <div className="font-bold capitalize text-[25px] text-[#017e89]">{t("Statitics")}</div>
                        </div>
                        <Statitics/>
                    </div>
                    <div className="flex flex-col gap-[15px]">
                        <div className="js-scroll fade-top flex items-baseline gap-[7px]">
                            <img className="w-[35px] h-auto" src={require("../../assets/icons/lineTitle.svg").default} alt="" />
                            <div className="font-bold capitalize text-[25px] text-[#017e89]">{t("Company Profile")}</div>
                        </div>
                        <div className="js-scroll fade-btm" style={{ width: "100%", height: "500px" }}>
                            <iframe
                                src={`${process.env.PUBLIC_URL}/company profile.pdf`}
                                width="100%"
                                height="100%"
                                title="Company Profile"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}